import { render, staticRenderFns } from "./BossExpiredFreeTrial.vue?vue&type=template&id=84eeb2e6&"
import script from "./BossExpiredFreeTrial.vue?vue&type=script&lang=js&"
export * from "./BossExpiredFreeTrial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports